import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import { NotFoundPage } from '@/components/ui/NotFoundPage';

function RootLayout() {
  return (
    <Suspense
      fallback={
        <div aria-live="polite" aria-busy="true">
          読み込み中...
        </div>
      }
    >
      <Outlet />
    </Suspense>
  );
}

export const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
});
